import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import type {
  GTMEventGlycerinDisplayLink,
  GTMEventGlycerinLinkClick,
  GTMEventGlycerinCheckboxClick,
} from '@packages/tracking/src/types/events';

export const useArticleServicesTracking = () => {
  const dispatchTracking = useTracking();

  const trackingGlycerinDisplayLink = ({
    category,
    detail,
  }: Pick<GTMEventGlycerinDisplayLink['DisplayLinkData'], 'category' | 'detail'>) => {
    dispatchTracking<GTMEventGlycerinDisplayLink>({
      event: 'DisplayLink',
      DisplayLinkData: {
        category,
        detail,
        label: 'APlus Service',
        target: 'Overlay',
      },
    });
  };

  const trackingGlycerinLinkClick = ({
    category,
    detail,
  }: Pick<GTMEventGlycerinLinkClick['LinkClickData'], 'category' | 'detail'>) => {
    dispatchTracking<GTMEventGlycerinLinkClick>({
      event: 'LinkClick',
      LinkClickData: {
        category,
        detail,
        label: 'APlus Service',
      },
    });
  };

  const trackingGlycerinCheckboxClick = ({
    isChecked,
    category,
    detail,
  }: Pick<
    GTMEventGlycerinCheckboxClick['CheckboxClickData'],
    'isChecked' | 'category' | 'detail'
  >) => {
    dispatchTracking<GTMEventGlycerinCheckboxClick>({
      event: 'CheckboxClick',
      CheckboxClickData: {
        isChecked,
        category,
        detail,
        label: 'APlus Service',
      },
    });
  };

  return { trackingGlycerinDisplayLink, trackingGlycerinLinkClick, trackingGlycerinCheckboxClick };
};
